import { CSS, StyleProps, callCSSFn, CSSFn } from "../styles"
import { boxCss } from "../Box"

export const makeContainerStyle = (css?: CSSFn) => (props: StyleProps) => ({
  ...boxCss,
  width: `100%`,
  overflow: `auto`,
  [props.theme.breakPoints.md.up]: {
    overflow: `hidden`,
  },
  ...callCSSFn({ ...props, css }),
})

export const contentContainer = (): CSS => ({
  position: `relative`,
})

export const loading = (props: StyleProps): CSS => ({
  position: `absolute`,
  top: `55px`,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: props.theme.palette.white,
})

export const customLink = (props: StyleProps): CSS => ({
  textDecoration: `none`,
  color: props.theme.palette.coal.dark,
})

export const removePaddings = (): CSS => ({
  padding: 0,
})

export const cellsStyles = (): CSS => ({
  padding: `0 1rem`,
  display: `flex`,
  alignItems: `center`,
  height: `100%`,
  justifyContent: `flex-start`,
})
